function isDev() {
  if (typeof window !== "undefined" && window.__UMD_DEV__ === true) {
    return true;
  }
  try {
    if (typeof process !== "undefined" && false) ;
  } catch {
  }
  return false;
}
function createLogger(componentName) {
  const prefix = `[UMD-DS:${componentName}]`;
  return {
    debug: (...args) => {
      if (isDev()) console.debug(prefix, ...args);
    },
    info: (...args) => {
      if (isDev()) console.info(prefix, ...args);
    },
    warn: (...args) => {
      console.warn(prefix, ...args);
    },
    error: (...args) => {
      console.error(prefix, ...args);
    },
    group: (...args) => {
      if (isDev()) console.group(prefix, ...args);
    },
    groupEnd: () => {
      if (isDev()) console.groupEnd();
    }
  };
}
const debugLoggerKey = /* @__PURE__ */ Symbol("debugLogger");
function withLifecycleDebug(Base) {
  var _a;
  return class LifecycleDebug extends (_a = Base, _a) {
    constructor(...args) {
      super(...args);
      const tag = this.tagName?.toLowerCase() ?? "unknown";
      this[debugLoggerKey] = createLogger(tag);
    }
    connectedCallback() {
      this[debugLoggerKey].debug("connectedCallback");
      const superProto = Object.getPrototypeOf(Object.getPrototypeOf(this));
      if (typeof superProto?.connectedCallback === "function") {
        superProto.connectedCallback.call(this);
      }
    }
    disconnectedCallback() {
      this[debugLoggerKey].debug("disconnectedCallback");
      const superProto = Object.getPrototypeOf(Object.getPrototypeOf(this));
      if (typeof superProto?.disconnectedCallback === "function") {
        superProto.disconnectedCallback.call(this);
      }
    }
    attributeChangedCallback(name, oldValue, newValue) {
      this[debugLoggerKey].debug("attributeChangedCallback", { name, oldValue, newValue });
      const superProto = Object.getPrototypeOf(Object.getPrototypeOf(this));
      if (typeof superProto?.attributeChangedCallback === "function") {
        superProto.attributeChangedCallback.call(this, name, oldValue, newValue);
      }
    }
  };
}
export {
  createLogger,
  isDev,
  withLifecycleDebug
};
//# sourceMappingURL=debug.js.map
